/**
 * Created by tschenkel on 6/30/2015.
 */

/**
 * List all errors that the module can dispatch.
 */
export class LocalizationModuleErrorConstants {
    public static CODE_MODULE_SETTINGS_NOT_PROVIDED: string = "001";
    public static MESSAGE_MODULE_SETTINGS_NOT_PROVIDED: string = "Module Settings can't be null";

    public static CODE_PROCESSOR_CLASS_IS_INVALID: string = "002";
    public static MESSAGE_PROCESSOR_CLASS_IS_INVALID: string = "Processor class is invalid";

    public static CODE_LANGUAGE_VO_IS_MANDATORY: string = "003";
    public static MESSAGE_LANGUAGE_VO_IS_MANDATORY: string = "LanguageVO is mandatory";

    public static CODE_ICU_PROCESSOR_NOT_AVAILABLE: string = "004";
    public static MESSAGE_ICU_PROCESSOR_NOT_AVAILABLE: string = "ICU Processor not available";

    public static CODE_ICU_PROCESSOR_NOT_INITIALIZED: string = "005";
    public static MESSAGE_ICU_PROCESSOR_NOT_INITIALIZED: string = "ICU Processor not initialized";

    public static CODE_ICU_PROCESSOR_HAS_NO_TIMEZONE: string = "006";
    public static MESSAGE_ICU_PROCESSOR_HAS_NO_TIMEZONE: string = "ICU Processor has no timezone";

    public static CODE_PROCESSOR_NOT_INITIALIZED: string = "007";
    public static MESSAGE_PROCESSOR_NOT_INITIALIZED: string = "Processor not initialized";

    public static CODE_TEXTS_DEFINITION_IS_MANDATORY: string = "008";
    public static MESSAGE_TEXTS_DEFINITION_IS_MANDATORY: string = "Texts definitions are mandatory";

    public static CODE_LOCALIZATION_MODULE_NOT_INSTALLED: string = "009";
    public static MESSAGE_LOCALIZATION_MODULE_NOT_INSTALLED: string = "Localization Module is not installed";
}
